
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ThemeProvider } from './context/ThemeContext';
import reportWebVitals from './reportWebVitals';
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import OnlineStatusProvider from './context/OnlineStatusProvider';
const PAYPAL_CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_ID;
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ThemeProvider>
       <PayPalScriptProvider options={{
          "client-id": PAYPAL_CLIENT_ID,
          vault: true,
          currency: "USD",
          
        }}>
            <OnlineStatusProvider>
      <App />
            </OnlineStatusProvider>

      </PayPalScriptProvider>
    </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
